export default __webpack_public_path__ + "static/media/gallery_05@2x.e4299277.jpg";